export { GiftHero } from "./GiftHero";
export type { GiftHeroProps } from "./GiftHero";
